<div class="response-message mt-3 font-weight-bold fader " 
	[ngClass]="{'fade-out': isFadeOut}"
	*ngIf="responseMsg.success || responseMsg.status || responseMsg.error">
	<div class="error" *ngIf="error">
		<div>{{error}}</div>
		<div class="details" *ngIf="details">{{details}}</div>
	</div>
	<div class="success" *ngIf="responseMsg.success">{{responseMsg.success}}</div>
	<div class="status" *ngIf="responseMsg.status">{{responseMsg.status}}</div>
</div>